<template>
  <v-container fluid grid-list-md text-xs-center>
    <v-card>
      <v-card-title>
        <h1>Find and replace text</h1>
      </v-card-title>
      <v-card-text>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field placeholder="Paste your search string here" v-model="find"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field placeholder="Paste your replace string here" v-model="replace"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Paste your text here" v-model="text"></v-textarea>
          </v-flex>
          <v-flex xs12 sm6>
            <v-textarea placeholder="Result" v-model="result"></v-textarea>
          </v-flex>
          <v-flex xs12>
            <v-btn color="primary" @click="findAndReplace()">Find and replace</v-btn>
          </v-flex>
          <actions :result="result" />
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    text: '',
    result: '',
    find: '',
    replace: ''
  }),
  methods: {
    findAndReplace() {
      const regExp = new RegExp(this.find, 'gi')
      this.result = this.text.replace(regExp, this.replace)
    }
  }
}
</script>

<style>
</style>